import React  from 'react';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import FormControl from "@material-ui/core/FormControl/FormControl";
import {withStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import {useSelector} from "react-redux";

const styles = theme => ({
    textField: {
        minWidth: 250,
        marginRight: theme.spacing(1),
        position: 'relative'
    },
    container: {
        marginBottom: theme.spacing(1) * 2
    },
    marginBottom: {
        marginBottom: '15px',
        minWidth: '250px'
    }
})


    const StepQuestion = ({ classes, question, onChange}) => {
        let type = parseInt(question.processoEtapaQuestao.tipoResposta? question.processoEtapaQuestao.tipoResposta : '0' ) || 0;

        const bandas = useSelector( st => st.tires.bandas.data)

        switch (question.processoEtapaQuestao.tipoPergunta) {
            case 261 :
                if (bandas) {
                    const b = bandas.find(b => b.id.toString() == question.resposta)
                    if (b) {
                        return (
                            <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                                <Typography  style={{fontSize: '0.8rem'}}>{question.processoEtapaQuestao.pergunta}</Typography>
                                <Typography  style={{fontSize: '1.1rem'}}>{`${b.descricao} (${question.resposta})`}</Typography>
                            </ListItem>
                        )
                    }
                }
        }


        switch (type) {
            case 1:
                return (
                    <FormControl className={classes.marginBottom}>
                        <Typography variant="subtitle1"  style={{fontSize: '0.8rem'}}> {question.processoEtapaQuestao.pergunta}</Typography>
                        <Select
                            value={question.Answer}
                            onChange={(e) => onChange({id: question.id, value: e.target.value})}
                            inputProps={{
                                name: question.processoEtapaQuestao.pergunta,
                                id: question.processoEtapaQuestao.id,
                            }}
                        >
                            //TODO: recolocar opcoes de respostas
                            {/*{question.processoEtapaQuestao.processStepQuestionAnswer.map((answerItem) => {*/}
                            {/*    return (*/}
                            {/*        <MenuItem value={answerItem.Description}>{answerItem.Description}</MenuItem>*/}
                            {/*    )*/}
                            {/*})}*/}
                        </Select>
                    </FormControl>

                )
            case 2:
                return (
                    <TextField
                        onChange={(e) => onChange({id: question.id, value: e.target.value})}
                        label={question.processoEtapaQuestao.pergunta}
                        defaultValue={question.resposta}
                        margin="normal"
                        type="number"
                        className={classes.marginBottom}
                    />
                )

            case 3:
                return (
                    <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                        <Typography  style={{fontSize: '0.8rem'}}>{question.processoEtapaQuestao.pergunta}</Typography>
                        <Typography  style={{fontSize: '0.8rem'}}>{question.resposta === '1'? 'SIM' :
                                                                   question.resposta === '0'? 'NAO' : '--'}</Typography>
                    </ListItem>
                )
            default:
                return (
                    <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                        <Typography  style={{fontSize: '0.8rem'}}>{question.processoEtapaQuestao.pergunta}</Typography>
                        <Typography  style={{fontSize: '1.1rem'}}>{question.resposta}</Typography>
                    </ListItem>
                )
        }

}
export default withStyles(styles, {withTheme: true})(StepQuestion);
